import axios from 'axios'
import { useEffect, useState } from 'react'
import { baseUrl } from '../../baseUrl'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../AuthContext'
import { MagnifyingGlass } from 'react-loader-spinner'

const MockTest = () => {
    const { user, loading: authLoading } = useAuth()
    const navigate = useNavigate()
    const [tests, setTests] = useState([])
    const [loading, setLoading] = useState(false)
    const getMockTests = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`${baseUrl}/exam/mock-test`)
            setTests(res.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!authLoading) {
            if (!user) {
                navigate('/login');
            } else {
                getMockTests();
            }
        }
    }, [authLoading, user]);
    return (
        <div className='container my-2'>
            <h4 className='text-center'>Mock Tests</h4>
            {
                !loading && tests.length > 0 &&
                <div className='table-responsive mt-2'>
                    <table>
                        <thead>
                            <tr>
                                <td>Sr no.</td>
                                <td>Name</td>
                                <td>Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tests.map((test, i) =>
                                    <tr>
                                        <td>{i + 1}</td>
                                        <td>{test.examName}</td>
                                        <td>
                                            <Link to={`/student/${user?.email}/exam/${test._id}`}><button className='btn btn-sm btn-success'>Start</button></Link>
                                        </td>
                                    </tr>)
                            }
                        </tbody>
                    </table>
                </div>
            }
            {
                loading &&
                <MagnifyingGlass
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="magnifying-glass-loading"
                    wrapperStyle={{}}
                    wrapperClass="magnifying-glass-wrapper"
                    glassColor="#c0efff"
                    color="#8000df"
                />
            }
            {
                !loading && tests.length < 1 &&
                <h4>Coming Soon...</h4>
            }
        </div>
    )
}

export default MockTest
